import { trigger, transition, style, animate } from '@angular/animations';

/**
 * Animations used by CoursePlayerLearnerModalComponent. Extracted to keep the
 * component file under the 600-line size threshold.
 */
export const learnerModalAnimations = [
  trigger('fadeIn', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('300ms ease', style({ opacity: 1 }))
    ])
  ]),
  trigger('slideIn', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(0.95)' }),
      animate('300ms ease', style({ opacity: 1, transform: 'scale(1)' }))
    ])
  ]),
  trigger('loadingPulse', [
    transition(':enter', [
      style({ opacity: 0, transform: 'scale(0.9)' }),
      animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1, transform: 'scale(1)' }))
    ])
  ]),
  trigger('contentFadeIn', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('500ms 100ms ease-out', style({ opacity: 1 }))
    ])
  ])
];
